/**
 * Canonical Question Type Constants and Normalizer for Frontend
 * Single Source of Truth for Question Types across Client Pages & Components.
 */

export const QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'multiple-choice',
  TRUE_FALSE: 'true-false',
  SHORT_ANSWER: 'short-answer',
  FILL_IN_BLANKS: 'fill-in-blanks',
  ESSAY: 'essay',
  CODE: 'code',
  PASSAGE_READING: 'passage-reading',
  PARAGRAPH_READING: 'paragraph-reading',
  // Personality statements answered 1..5 (IPIP-50); no correct answer.
  LIKERT: 'likert',
};

export const QUESTION_TYPE_LABELS = {
  [QUESTION_TYPES.MULTIPLE_CHOICE]: 'Multiple Choice',
  [QUESTION_TYPES.TRUE_FALSE]: 'True / False',
  [QUESTION_TYPES.SHORT_ANSWER]: 'Short Answer',
  [QUESTION_TYPES.FILL_IN_BLANKS]: 'Fill In The Blanks',
  [QUESTION_TYPES.ESSAY]: 'Essay',
  [QUESTION_TYPES.CODE]: 'Coding Challenge',
  [QUESTION_TYPES.PASSAGE_READING]: 'Passage Reading',
  [QUESTION_TYPES.PARAGRAPH_READING]: 'Paragraph Reading',
  [QUESTION_TYPES.LIKERT]: 'Personality Statement',
};

const CANONICAL_SET = new Set(Object.values(QUESTION_TYPES));

/**
 * Normalizes any question type string to canonical type enum
 * @param {string} rawType
 * @returns {string} Canonical type string
 */
export function normalizeQuestionType(rawType) {
  if (!rawType || typeof rawType !== 'string') return QUESTION_TYPES.SHORT_ANSWER;
  const lower = rawType.trim().toLowerCase();

  if (CANONICAL_SET.has(lower)) {
    return lower;
  }

  if (lower.includes('fill') && lower.includes('blank')) {
    return QUESTION_TYPES.FILL_IN_BLANKS;
  }
  if (lower.includes('true') && lower.includes('false')) {
    return QUESTION_TYPES.TRUE_FALSE;
  }
  if (lower.includes('multiple') || lower === 'mcq') {
    return QUESTION_TYPES.MULTIPLE_CHOICE;
  }
  if (lower.includes('likert')) {
    return QUESTION_TYPES.LIKERT;
  }
  if (lower.includes('passage')) {
    return QUESTION_TYPES.PASSAGE_READING;
  }
  if (lower.includes('paragraph')) {
    return QUESTION_TYPES.PARAGRAPH_READING;
  }
  if (lower.includes('code')) {
    return QUESTION_TYPES.CODE;
  }
  if (lower.includes('essay')) {
    return QUESTION_TYPES.ESSAY;
  }
  if (lower.includes('short') || lower.includes('answer') || lower.includes('number')) {
    return QUESTION_TYPES.SHORT_ANSWER;
  }

  return QUESTION_TYPES.SHORT_ANSWER;
}
